import { render } from "./loginPage.vue?vue&type=template&id=ae957b9a"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__